import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

//interfaces
import { ModeloGpsInterface } from "../../../../interfaces/ModeloGpsInterface";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

//estilos
const classes = require("./ModeloGpsEdit.module.css").default;

/**
 * UusarioEdit Component
 * @description: Componente que permite editar un modeloGps.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de modeloGpss.
 */

const ModeloGpsEdit = () => {
  const { idModeloGps } = useParams();
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();
  const [modeloGps, setModeloGps] = useState<ModeloGpsInterface>();
  const [show, setShow] = useState(false);

  //Variables de formulario
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: modeloGps?.nombre,
    },
  });

  //Función que trata el detalle de modeloGps.
  const transformData = useCallback(
    (variable: any) => {
      setModeloGps(variable.data);
      reset(variable.data);
    },
    [reset]
  );

  //Se recibe el modeloGps a editar
  useEffect(() => {
    sendRequest(
      {
        url: `/modelo_gps/${idModeloGps}`,
      },
      transformData
    );
  }, [idModeloGps, sendRequest, transformData]);

  //Función que solicita la edición del modeloGps
  const updateModeloGps = (data: any) => {
    sendRequest(
      {
        url: `/modelo_gps/${idModeloGps}`,
        method: "PATCH",
        body: data,
      },
      (variable: any) => {
        setShow(true);
      }
    );
  };

  //Mientras se carga el contenido se muestra un spinner
  if (!modeloGps) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Edición del modelo de GPS {idModeloGps}</h2>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Modelo de GPS actualizado"
          body="El modelo de GPS  ha sido actualizado de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}

      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(updateModeloGps)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 50,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 50 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default ModeloGpsEdit;
